var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardLimits(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 16.5C11 14.0148 13.0148 12 15.5 12C17.9852 12 20 14.0148 20 16.5C20 18.9852 17.9852 21 15.5 21C13.0148 21 11 18.9852 11 16.5ZM15.5 13C13.567 13 12 14.567 12 16.5C12 18.433 13.567 20 15.5 20C17.433 20 19 18.433 19 16.5C19 14.567 17.433 13 15.5 13Z",
    fill: "#6CC980"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6815 13.3184C18.8767 13.5136 18.8767 13.8302 18.6814 14.0255L13.0254 19.6808C12.8302 19.876 12.5136 19.876 12.3183 19.6807C12.1231 19.4855 12.1231 19.1689 12.3184 18.9736L17.9744 13.3183C18.1696 13.1231 18.4862 13.1231 18.6815 13.3184Z",
    fill: "#6CC980"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9 6.5C3.9 5.61635 4.61635 4.9 5.5 4.9H16.5C17.3837 4.9 18.1 5.61636 18.1 6.5V10.5C18.1 10.8314 17.8314 11.1 17.5 11.1C17.1686 11.1 16.9 10.8314 16.9 10.5V6.5C16.9 6.27908 16.7209 6.1 16.5 6.1H5.5C5.27909 6.1 5.1 6.27909 5.1 6.5V14.5C5.1 14.7209 5.27908 14.9 5.5 14.9H9.5C9.83137 14.9 10.1 15.1686 10.1 15.5C10.1 15.8314 9.83137 16.1 9.5 16.1H5.5C4.61636 16.1 3.9 15.3837 3.9 14.5V6.5Z",
    fill: "#6CC980"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9 8.5C3.9 8.16863 4.16863 7.9 4.5 7.9H17.5C17.8314 7.9 18.1 8.16863 18.1 8.5C18.1 8.83137 17.8314 9.1 17.5 9.1H4.5C4.16863 9.1 3.9 8.83137 3.9 8.5Z",
    fill: "#6CC980"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 11C6 10.7239 6.22386 10.5 6.5 10.5H10.5C10.7761 10.5 11 10.7239 11 11C11 11.2761 10.7761 11.5 10.5 11.5H6.5C6.22386 11.5 6 11.2761 6 11Z",
    fill: "#6CC980"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 13C6 12.7239 6.22386 12.5 6.5 12.5H8.5C8.77614 12.5 9 12.7239 9 13C9 13.2761 8.77614 13.5 8.5 13.5H6.5C6.22386 13.5 6 13.2761 6 13Z",
    fill: "#6CC980"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11.5C6.224 11.5 6 11.276 6 11C6 10.724 6.224 10.5 6.5 10.5H10.5C10.776 10.5 11 10.724 11 11C11 11.276 10.776 11.5 10.5 11.5H6.5Z",
    fill: "#6CC980"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13.5C6.224 13.5 6 13.276 6 13C6 12.724 6.224 12.5 6.5 12.5H8.5C8.776 12.5 9 12.724 9 13C9 13.276 8.776 13.5 8.5 13.5H6.5Z",
    fill: "#6CC980"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardLimits);
export default __webpack_public_path__ + "static/media/card-limits.f15da839.svg";
export { ForwardRef as ReactComponent };